var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CC2F3F42-14D0-46E5-82BC-4DF1493B81F5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.405%",
    y1: "20.8175%",
    x2: "76.16%",
    y2: "64.7475%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: "0.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.495%",
    y1: "44.155%",
    x2: "81.31%",
    y2: "88.06875%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA7B0",
    offset: "99.8%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 37,
    transform: "translate(-80.000000, -697.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "poland",
    transform: "translate(80.000000, 697.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 L0,16 C0,24.8368 7.1632,32 16,32 C24.8368,32 32,24.8368 32,16 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C7.1632,0 0,7.1632 0,16 L32,16 C32,7.1632 24.8368,0 16,0 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl);
export default __webpack_public_path__ + "static/media/pl.7bb59343210eaf2ae34fb6893080434f.svg";
export { ForwardRef as ReactComponent };